import { TemplateResult } from 'lit-html';
import './voyage-dialog-popup';
import { VoyageDialogPopup } from './voyage-dialog-popup';

interface CreateDialogOptions
{
    headerText: string;
    bodyText?: string;
    bodyContent?: TemplateResult | HTMLElement;
    acceptButtonText?: string;
    noAcceptButton?: boolean;
    rejectButtonText?: string;
    noCloseButton?: boolean;
    isError?: boolean;
    errorDetails?: string;
    alignLeft?: boolean;
    secondaryButtonText?: string;
    noHeaderBox?: boolean;
    subText?: string;
}

export const VoyageDialogPopupManager = new class
{
    createDialog(options: CreateDialogOptions)
    {
        const newDialog = <VoyageDialogPopup>(document.createElement('voyage-dialog-popup'));
        
        newDialog.headerText = options.headerText;
        
        newDialog.acceptButtonText = options.acceptButtonText || newDialog.acceptButtonText;

        if (options.noAcceptButton)
        {
             newDialog.noAcceptButton = true;
        }

        newDialog.rejectButtonText = options.rejectButtonText || "";

        newDialog.secondaryButtonText = options.secondaryButtonText || "";
        
        if (options.bodyText)
        {
            newDialog.bodyText = options.bodyText;
        }

        if (options.bodyContent)
        {
            newDialog.bodyContent = options.bodyContent;
        }

        if (options.noCloseButton)
        {
             newDialog.noCloseButton = true;
        }
       
        if (options.isError)
        {
            newDialog.isError = true;
            newDialog.errorDetails = options.errorDetails!;
        }
        if (options.alignLeft)
        {
                newDialog.alignLeft = true
        }
        if(options.subText){
            newDialog.subText = options.subText;
        }
        document.body.appendChild(newDialog);

        return newDialog;
    }
}